import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Collapse } from "react-bootstrap";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import VariantDropdown from "../common/VariantDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";

function BroadcastMessageGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    if (props.filter) setFilter(props.filter);
    const filterIsEmpty = !props.filter || Object.values(props.filter).every(
      (x) => x === null || x === "" || x === undefined
    );
    setExpanded(!filterIsEmpty);

    // Depend on the actual filter VALUES, not the whole `props` object — `props` is a new
    // reference on every parent re-render for unrelated reasons, which was re-firing this
    // effect and force-collapsing the panel the instant it was expanded.
    // eslint-disable-next-line
  }, [props.filter?.displayedOn, props.filter?.variant]);

  const onKeyDown = (e) => {
    if (e.key === "Enter") GridHelper.handleSearch(filter, location, navigate);
  };

  return (
    <div className="bg-light border p-3 mb-3 rounded" onKeyDown={onKeyDown}>
      <Collapse in={expanded}>
        <div>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Variant</Form.Label>
                <VariantDropdown
                  value={filter.variant ?? ""}
                  onChange={(e) =>
                    setFilter({ ...filter, variant: e.target.value })
                  }
                  displayEmpty={true}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Displayed on</Form.Label>
                <Form.Control
                  value={filter.displayedOn ?? ""}
                  onChange={(e) =>
                    setFilter({ ...filter, displayedOn: e.target.value })
                  }
                  type="date"
                />
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="link"
            size="sm"
            className="text-decoration-none p-0 m-0 float-start mt-4 fw-bold"
            onClick={() => setExpanded(!expanded)}
          >
            Click here to collapse filters <FaAngleUp size={13} />
          </Button>
          <Button
            variant="primary"
            className="float-end mt-3"
            onClick={() => GridHelper.handleSearch(filter, location, navigate)}
          >
            Search
          </Button>
          <Button
            variant="secondary"
            className="float-end mt-3 me-2"
            onClick={() => props.onClearFilters()}
          >
            Clear filters
          </Button>
          <div className="clearfix" />
        </div>
      </Collapse>
      {!expanded && (
        <Button
          variant="link"
          size="sm"
          className="text-decoration-none p-0 m-0 fw-bold"
          onClick={() => setExpanded(!expanded)}
        >
          Click here to expand filters <FaAngleDown size={13} />
        </Button>
      )}
    </div>
  );
}

export default BroadcastMessageGridFilter;
